import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Oval } from 'react-loader-spinner';



function Banner() {
  const [banner, setBanner] = useState("");
  useEffect(() => {
    axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=bfc2dc001ad661990f954af88f5d31c6").then((res) =>
      setBanner(res.data.results[0]),
      // console.table(res.data.results)

    )
  }, [])
  return (
    <div>
      {banner == "" ? <div className="flex justify-center"> <Oval
        height="150"
        width="150"
        radius="15"
        color="gray"
        secondaryColor="gray"
        ariaLabel="loading"
      /> </div>
        :
        <div className="h-[95vh] flex items-end bg-center bg-cover"
          style={{
            backgroundImage: `url(https://image.tmdb.org/t/p/original/${banner.backdrop_path})`
          }} >
          <div className='text-white  text-7xl bg-gray-500 bg-opacity-60 p-3 w-full text-center'>{banner.title}</div>
        </div>


      }

    </div>
  )
}

export default Banner;